/**
Project: Voice Panel (c)
Title: Service Number Table Header Columns  
Description: Settings related to Services list page table header column 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import IntlUtil from "../../../../core/helpers/intl-util";

export const ServiceNumberStatusTableHeaderColumns = (intlNamespace) => [
  {
    key: 1,
    content: IntlUtil.getText(intlNamespace, "content.userName"),
    cellClassName: "vpa-usn-dialog-table-header-cell",
  },
  {
    key: 2,
    content: IntlUtil.getText(intlNamespace, "content.updateType"),
    cellClassName: "vpa-usn-dialog-table-header-cell max-w-120",
  },
  {
    key: 3,
    content: IntlUtil.getText(intlNamespace, "content.updateValue"),
    cellClassName: "vpa-usn-dialog-table-header-cell max-w-170",
  },
  {
    key: 4,
    content: IntlUtil.getText(intlNamespace, "content.status"),
    cellClassName: "vpa-usn-dialog-table-header-cell max-w-170",
  },
  {
    key: 5,
    content: IntlUtil.getText(intlNamespace, "content.errorMessage"),
    cellClassName: "vpa-usn-dialog-table-header-cell",
  },
];
